import { Component, OnInit } from '@angular/core';
import {SALES_URL} from '../../app.constants';

@Component({
  selector: 'app-community',
  templateUrl: './community.component.html',
  styleUrls: ['./community.component.sass']
})
export class CommunityComponent implements OnInit {

  constructor() { }

  items = [
    {
      type: 'hotel',
      title: 'Ainda não decidiu o seu hotel?',
      subtitle: 'Pesquise a disponibilidade no botão abaixo.',
      classCss: 'comunidade__items--item-button_hotel',
      styleCss: {},
      textButton: 'PESQUISAR HOTÉIS',
      link: `${SALES_URL}/listagemhoteis/s/`,
    },
    {
      type: 'community',
      title: 'Vai reservar uma hospedagem ou quer verificar a sua assinatura?',
      subtitle: 'Acesse a community.',
      classCss: 'comunidade__items--item-button_comunidade',
      styleCss: {'margin-left': '1rem'},
      textButton: 'ACESSAR COMUNIDADE',
      link: `${SALES_URL}/comunidade/s/login/`
    }
  ];

  ngOnInit() {
  }

  goTo(link: string) {
    window.open(link, '_top');
  }
}
